export const faqItems = [
  {
    question: 'Qual o valor do sistema e como funciona a cobrança?',
    answer: 'Acreditamos que cada posto tem sua realidade. Por isso, cobramos uma mensalidade fixa ajustada ao volume de CNPJs e módulos (como Smart POS ou Fidelidade) que você realmente utiliza. Sem taxas ocultas de implantação abusiva. Fale com nosso consultor para uma cotação exata em 2 minutos.',
  },
  {
    question: 'A migração do meu sistema atual vai fazer o meu posto parar?',
    answer: 'Nunca. Sabemos que a pista não para. Nossa equipe realiza a transição de bancos de dados e a instalação de harware durante a madrugada ou nos horários de menor movimento do seu posto, de forma ágil e silenciosa.',
  },
  {
    question: 'Como funciona o suporte técnico? Tem atendimento de final de semana?',
    answer: 'Sim! Se o seu posto opera no domingo à noite, nosso suporte também está disponível para você. Atendimento humano, rápido e por WhatsApp, porque sabemos que na ponta da pista, tempo é dinheiro.',
  },
  {
    question: 'A integração entre a Retaguarda (ERP) e o PDV é na mesma hora?',
    answer: 'Imediata. Diferente de sistemas engessados, o ecosistema Lukos é 100% cloud nativo. Uma venda realizada com a maquininha Smart POS ou no Caixa cai instantaneamente no seu painel gerencial web de onde você estiver.',
  }
];

export const blogPostsData = [
  {
    id: 1,
    title: 'Software ERP & Retaguarda',
    excerpt: 'Gestão sólida para múltiplos postos e lojas. Centralize sua operação, fiscal e financeiro em uma plataforma 100% cloud.',
    author: 'LUKOS',
    date: 'Lançamento',
    readTime: 'Solução ERP',
    category: 'Software',
    image: '/blog/conciliacao_v2.png',
    link: '/lukos',
  },
  {
    id: 2,
    title: 'Automação de Pista (PDV)',
    excerpt: 'Agilidade total no atendimento com Smart POS. Emissão de NFC-e na pista e integração direta com bombas e tanques.',
    author: 'LUKOS',
    date: 'Lançamento',
    readTime: 'Automação',
    category: 'Mobilidade',
    image: '/blog/lukos_pay.png',
    link: '/lukos',
  },
  {
    id: 3,
    title: 'Conciliação & Lukos Pay',
    excerpt: 'Sua conta digital integrada. Auditoria automática de cartões e PIX, garantindo que você receba o valor exato de cada venda.',
    author: 'LUKOS',
    date: 'Lançamento',
    readTime: 'Fintech',
    category: 'Pagamentos',
    image: '/blog/conciliacao_v2.png',
    link: '/lukos',
  },
  {
    id: 4,
    title: 'LukIA: Inteligência Artificial',
    excerpt: 'IA preditiva que monitora sua rede 24/7. Receba alertas de fraudes, sugestões de preços e relatórios direto no WhatsApp.',
    author: 'LUKOS',
    date: 'Lançamento',
    readTime: 'IA Nativa',
    category: 'Inovação',
    image: '/blog/lukia_v2.png',
    link: '/lukos',
  },
];
